var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4401 8.75425C35.1281 9.36578 35.1901 10.4192 34.5785 11.1072L16.8008 31.1072C16.4845 31.463 16.0311 31.6666 15.5551 31.6666C15.079 31.6666 14.6257 31.463 14.3094 31.1072L6.52761 24.0195C5.91608 23.3316 5.97804 22.2781 6.66602 21.6666C7.35399 21.0551 8.40744 21.117 9.01897 21.805L15.5551 27.4913L32.0872 8.89266C32.6987 8.20469 33.7522 8.14272 34.4401 8.75425Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBigIcon);
export default __webpack_public_path__ + "static/media/tickBigIcon.ba44126aeab587652edfab22eac460df.svg";
export { ForwardRef as ReactComponent };